var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"container-fluid"},[(_vm.loaded)?_c('div',{staticClass:"container-fluid"},[_c('kibana',{attrs:{"dimensions":_vm.kibanaDimensions,"kibanaLocation":_vm.kibanaLocation}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }